// extracted by mini-css-extract-plugin
export default {"blockCode":"CodeBlock_blockCode__w4G2V","codeLines":"CodeBlock_codeLines__MQ3+n"};